export default {
    computed: {
        isHappyCoin() {
            const isHappyCoinRoute = this.$route.matched.some(
                (route) => route.meta.currencyMode === "happyCoin"
            );
            return isHappyCoinRoute || this.$route.query.uhc == 1;
        },
    },
};
